if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      
      const properties = document.querySelectorAll('.product__line_item_property') || [];
      let additionalData = [];
      for (let index = 0; index < properties.length; index++) {
        const property = properties[index];
        const type = property.getAttribute('data-type');
        let formGroup = type == 'radio' ? property.querySelector('.form__groups-radio') : type == 'checkbox' ? property.querySelector('.form__groups-checkbox') : property.querySelector('.form__group');
        
        if (type == 'radio') {
          const input = property.querySelector('input');
          const selectedRadio = property.querySelector('input:checked');
          const radioValue = selectedRadio ? selectedRadio.value : null;
          const error = input.hasAttribute('required') && !radioValue ? true : false;
          additionalData = [...additionalData, {
            name: input.name,
            value: radioValue,
            error: error
          }];
          
          if (error) {
            input.focus();
            input.reportValidity();
            if (formGroup) formGroup.classList.add('error');
          } else {
            if (formGroup) formGroup.classList.remove('error');
          }
        } else {
          const input = property.querySelector('input, textarea, select');
          let error = false;
          if (type == 'checkbox') {
            error = input.hasAttribute('required') && !input.checked ? true : false;
          } else {
            error = input.hasAttribute('required') && !input.value.trim() ? true : false;
          }
          additionalData = [...additionalData, {
            name: input.name,
            value: input.value.trim(),
            error: error
          }];
          if (error) {
            input.focus();
            input.reportValidity();
            if (formGroup) formGroup.classList.add('error');
          } else {
            if (formGroup) formGroup.classList.remove('error');
          }
        }
      }

      const validAdditionalData = additionalData.every(d => !d.error);
      if (additionalData.length > 0 && !validAdditionalData) return;
      
      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        for (let index = 0; index < additionalData.length; index++) {
          const data = additionalData[index];
          formData.append(data.name, data.value);
        }
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      const giftWrap = this.getGiftWrapOption();
      const wantsGiftWrap = !!(giftWrap && giftWrap.checked);
      const mayOweFreeGift = !!(window.freeGift && window.freeGift.enabled);
      const addToCart =
        wantsGiftWrap || mayOweFreeGift
          ? this.addWithExtras(formData, wantsGiftWrap ? giftWrap : null)
          : fetch(`${routes.cart_add_url}`, config);

      addToCart
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            this.error = true;
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if ( document.querySelector('.quick-options-drawer.open') != null ) {
            document.querySelector('.quick-options-drawer.open').classList.remove('open');
            document.querySelector('body').classList.remove('quick-options-open');
          }


          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
          this.error = false;
          const quickAddModal = document.getElementById('product-quick-add-dialog');
          if (quickAddModal) {
            quickAddModal.hide();
            this.cart.renderContents(response);
          } else {
            this.cart.renderContents(response);
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }


    // The gift wrap toggle lives in its own block, outside this form. Scope the
    // lookup to the surrounding section so a quick-add modal never picks up the
    // toggle belonging to the product page behind it.
    getGiftWrapOption() {
      const scope = this.closest('.shopify-section') || document;
      return scope.querySelector('gift-wrap-option');
    }

    buildItemFromFormData(formData) {
      const item = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1,
      };

      const properties = {};
      let hasProperties = false;
      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') {
          properties[match[1]] = value;
          hasProperties = true;
        }
      });
      if (hasProperties) item.properties = properties;

      return item;
    }

    // Adds the product and anything that must ride along with it - the gift wrap
    // and the free gift - in one /cart/add.js call, so they can never land apart.
    addWithExtras(formData, giftWrap) {
      const mainItem = this.buildItemFromFormData(formData);
      const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

      const cartState = giftWrap
        ? giftWrap.refreshFromCart()
        : fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .catch(() => null);

      return cartState
        .then((cart) => {
          const items = [mainItem];
          let updateWrapProperties = null;

          if (giftWrap) {
            const existingLine = giftWrap.syncFromCart(cart);
            const wrapQuantity = giftWrap.quantityToAdd(mainItem.quantity);
            const properties = giftWrap.properties();

            if (wrapQuantity > 0) {
              items.push({ id: giftWrap.variantId, quantity: wrapQuantity, properties: properties });
            } else if (existingLine) {
              // Wrap already in the cart: refresh its message rather than duplicate it.
              const current = JSON.stringify(existingLine.properties || {});
              if (current !== JSON.stringify(properties)) {
                updateWrapProperties = { id: existingLine.key, properties: properties };
              }
            }
          }

          const freeGift =
            typeof window.freeGiftItemFor === 'function'
              ? window.freeGiftItemFor(cart, mainItem.quantity)
              : null;
          if (freeGift) items.push(freeGift);

          const body = { items: items };
          if (this.cart) {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }

          const add = () =>
            fetch(`${routes.cart_add_url}.js`, {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify(body),
            });

          if (updateWrapProperties) {
            return fetch(`${routes.cart_change_url}.js`, {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify(updateWrapProperties),
            }).then(add);
          }

          return add();
        })
        .then((response) =>
          response.json().then((data) => {
            // The multi-item response has no top level `id`; cart-notification needs one.
            if (!data.status && data.items && data.items.length) data.id = data.items[0].id;
            return { json: () => Promise.resolve(data) };
          })
        );
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      if (errorMessage) {
        this.errorMessageWrapper.classList.add('flex');
        this.errorMessageWrapper.classList.remove('hidden');
      } else {
        this.errorMessageWrapper.classList.add('hidden');
        this.errorMessageWrapper.classList.remove('flex');
      }

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
